import { createContext } from 'react'

export interface AppStateContextValue {
  expoPushToken: string | null
  hideMatchSheet: boolean
  reload: () => void
  setExpoPushToken: (token: string | null) => Promise<void>
  setHideMatchSheet: (hide: boolean) => Promise<void>
}

export const AppStateContext = createContext<AppStateContextValue>({
  expoPushToken: null,
  hideMatchSheet: false,
  reload: () => {},
  setExpoPushToken: Promise.resolve,
  setHideMatchSheet: Promise.resolve
})
